const AccordeonExport = (function () {
	const Accordeon = () => {
		const elements = document.querySelectorAll('.element');

		elements.forEach((element) => {
			const item = element;
			let icon = element.querySelector('.question button');
			var answer = element.lastElementChild;
			var answers = document.querySelectorAll('.element .answer');
			item.addEventListener('click', () => {
				answers.forEach((ans) => {
					//console.log(ans);
					let ansIcon = ans.parentElement.querySelector('button');
					if (answer !== ans) {
						ans.classList.add('hideText');
						ansIcon.innerHTML = '+';
					}
				});
				answer.classList.toggle('hideText');
				icon.innerHTML === '+'
					? (icon.innerHTML = '-')
					: (icon.innerHTML = '+');
			});
		});
	};

	return {
		getChildFunctions: function () {
			try {
				Accordeon();
			} catch (error) {
				console.log(error);
			}
		},
	};
})();

const getChildsAccordeon = () => {
	AccordeonExport.getChildFunctions();
};

export { getChildsAccordeon };
